import { Skeleton } from 'antd';
import React from 'react';

const ChatMessagesSkeleton = () => {
  return (
    // className lets host layouts re-align the skeleton column — e.g. the employee rail-docked view
    // adds padding-right so the skeleton centers on the SAME axis as the real messages + composer
    // (without it, the skeleton centered in the full panel width and slid under the rail cards).
    <div className="chat-messages-skeleton" style={{ 
      height: '100%', 
      display: 'flex', 
      flexDirection: 'column',
      alignItems: 'center',
      padding: '24px'
    }}>
      <div style={{ 
        flex: 1, 
        overflow: 'hidden',
        maxWidth: '800px',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: '24px'
      }}>
        <div style={{ display: 'flex', gap: '12px', alignItems: 'flex-start' }}>
          <Skeleton.Avatar active size={32} />
          <div style={{ flex: 1 }}>
            <Skeleton active paragraph={{ rows: 2 }} />
          </div>
        </div>
        
        <div style={{ display: 'flex', gap: '12px', alignItems: 'flex-start' }}>
          <Skeleton.Avatar active size={32} />
          <div style={{ flex: 1 }}>
            <Skeleton active paragraph={{ rows: 3 }} />
          </div>
        </div>
        
        <div style={{ display: 'flex', gap: '12px', alignItems: 'flex-start' }}>
          <Skeleton.Avatar active size={32} />
          <div style={{ flex: 1 }}>
            <Skeleton active paragraph={{ rows: 2 }} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChatMessagesSkeleton;
